import ClosingScreen from './ClosingScreen'

export default ClosingScreen
